// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MyPicksRouteImport } from './routes/my-picks'
import { Route as RoutesIndexRouteImport } from './routes/routes-index'
import { Route as SeoStatusRouteImport } from './routes/seo-status'
import { Route as StateSlugGameSlugRouteImport } from './routes/$stateSlug.$gameSlug'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminGamesRouteImport } from './routes/admin.games'
import { Route as AdminNewsletterRouteImport } from './routes/admin.newsletter'
import { Route as Cash4lifeHowToPlayRouteImport } from './routes/cash4life.how-to-play'
import { Route as GamesGameSlugRouteImport } from './routes/games.$gameSlug'
import { Route as GoLinkIdRouteImport } from './routes/go.$linkId'
import { Route as LottoAmericaHowToPlayRouteImport } from './routes/lotto-america.how-to-play'
import { Route as MegaMillionsHowToPlayRouteImport } from './routes/mega-millions.how-to-play'
import { Route as MegaMillionsJackpotAnalysisRouteImport } from './routes/mega-millions.jackpot-analysis'
import { Route as PowerballHowToPlayRouteImport } from './routes/powerball.how-to-play'
import { Route as PowerballJackpotAnalysisRouteImport } from './routes/powerball.jackpot-analysis'
import { Route as ResultsIndexRouteImport } from './routes/results.index'
import { Route as ResultsDateRouteImport } from './routes/results.$date'
import { Route as StatesIndexRouteImport } from './routes/states.index'
import { Route as StatesStateSlugRouteImport } from './routes/states.$stateSlug'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as ToolsFrequencyAnalyzerRouteImport } from './routes/tools.frequency-analyzer'
import { Route as ToolsNumberGeneratorRouteImport } from './routes/tools.number-generator'
import { Route as ToolsPayoutCalculatorRouteImport } from './routes/tools.payout-calculator'
import { Route as ToolsResultsCheckerRouteImport } from './routes/tools.results-checker'
import { Route as StateSlugGameSlugIndexRouteImport } from './routes/$stateSlug.$gameSlug.index'
import { Route as StateSlugGameSlugHistoryRouteImport } from './routes/$stateSlug.$gameSlug.history'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as GamesGameSlugIndexRouteImport } from './routes/games.$gameSlug.index'
import { Route as GamesGameSlugHistoryRouteImport } from './routes/games.$gameSlug.history'
import { Route as StatesStateSlugIndexRouteImport } from './routes/states.$stateSlug.index'
import { Route as StatesStateSlugClaimPrizeRouteImport } from './routes/states.$stateSlug.claim-prize'
import { Route as ToolsTaxCalculatorIndexRouteImport } from './routes/tools.tax-calculator.index'
import { Route as ToolsTaxCalculatorStateSlugRouteImport } from './routes/tools.tax-calculator.$stateSlug'
import { Route as StateSlugGameSlugResultsDateRouteImport } from './routes/$stateSlug.$gameSlug.results.$date'
import { Route as GamesGameSlugResultsDateRouteImport } from './routes/games.$gameSlug.results.$date'
import { Route as StatesStateSlugInstantGameSlugRouteImport } from './routes/states.$stateSlug.instant.$gameSlug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const MyPicksRoute = MyPicksRouteImport.update({
            id: '/my-picks',path: '/my-picks',getParentRoute: () => rootRouteImport
          })
const RoutesIndexRoute = RoutesIndexRouteImport.update({
            id: '/routes-index',path: '/routes-index',getParentRoute: () => rootRouteImport
          })
const SeoStatusRoute = SeoStatusRouteImport.update({
            id: '/seo-status',path: '/seo-status',getParentRoute: () => rootRouteImport
          })
const StateSlugGameSlugRoute = StateSlugGameSlugRouteImport.update({
            id: '/$stateSlug/$gameSlug',path: '/$stateSlug/$gameSlug',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminGamesRoute = AdminGamesRouteImport.update({
            id: '/admin/games',path: '/admin/games',getParentRoute: () => rootRouteImport
          })
const AdminNewsletterRoute = AdminNewsletterRouteImport.update({
            id: '/admin/newsletter',path: '/admin/newsletter',getParentRoute: () => rootRouteImport
          })
const Cash4lifeHowToPlayRoute = Cash4lifeHowToPlayRouteImport.update({
            id: '/cash4life/how-to-play',path: '/cash4life/how-to-play',getParentRoute: () => rootRouteImport
          })
const GamesGameSlugRoute = GamesGameSlugRouteImport.update({
            id: '/games/$gameSlug',path: '/games/$gameSlug',getParentRoute: () => rootRouteImport
          })
const GoLinkIdRoute = GoLinkIdRouteImport.update({
            id: '/go/$linkId',path: '/go/$linkId',getParentRoute: () => rootRouteImport
          })
const LottoAmericaHowToPlayRoute = LottoAmericaHowToPlayRouteImport.update({
            id: '/lotto-america/how-to-play',path: '/lotto-america/how-to-play',getParentRoute: () => rootRouteImport
          })
const MegaMillionsHowToPlayRoute = MegaMillionsHowToPlayRouteImport.update({
            id: '/mega-millions/how-to-play',path: '/mega-millions/how-to-play',getParentRoute: () => rootRouteImport
          })
const MegaMillionsJackpotAnalysisRoute = MegaMillionsJackpotAnalysisRouteImport.update({
            id: '/mega-millions/jackpot-analysis',path: '/mega-millions/jackpot-analysis',getParentRoute: () => rootRouteImport
          })
const PowerballHowToPlayRoute = PowerballHowToPlayRouteImport.update({
            id: '/powerball/how-to-play',path: '/powerball/how-to-play',getParentRoute: () => rootRouteImport
          })
const PowerballJackpotAnalysisRoute = PowerballJackpotAnalysisRouteImport.update({
            id: '/powerball/jackpot-analysis',path: '/powerball/jackpot-analysis',getParentRoute: () => rootRouteImport
          })
const ResultsIndexRoute = ResultsIndexRouteImport.update({
            id: '/results/',path: '/results/',getParentRoute: () => rootRouteImport
          })
const ResultsDateRoute = ResultsDateRouteImport.update({
            id: '/results/$date',path: '/results/$date',getParentRoute: () => rootRouteImport
          })
const StatesIndexRoute = StatesIndexRouteImport.update({
            id: '/states/',path: '/states/',getParentRoute: () => rootRouteImport
          })
const StatesStateSlugRoute = StatesStateSlugRouteImport.update({
            id: '/states/$stateSlug',path: '/states/$stateSlug',getParentRoute: () => rootRouteImport
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => rootRouteImport
          })
const ToolsFrequencyAnalyzerRoute = ToolsFrequencyAnalyzerRouteImport.update({
            id: '/tools/frequency-analyzer',path: '/tools/frequency-analyzer',getParentRoute: () => rootRouteImport
          })
const ToolsNumberGeneratorRoute = ToolsNumberGeneratorRouteImport.update({
            id: '/tools/number-generator',path: '/tools/number-generator',getParentRoute: () => rootRouteImport
          })
const ToolsPayoutCalculatorRoute = ToolsPayoutCalculatorRouteImport.update({
            id: '/tools/payout-calculator',path: '/tools/payout-calculator',getParentRoute: () => rootRouteImport
          })
const ToolsResultsCheckerRoute = ToolsResultsCheckerRouteImport.update({
            id: '/tools/results-checker',path: '/tools/results-checker',getParentRoute: () => rootRouteImport
          })
const StateSlugGameSlugIndexRoute = StateSlugGameSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => StateSlugGameSlugRoute
          })
const StateSlugGameSlugHistoryRoute = StateSlugGameSlugHistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => StateSlugGameSlugRoute
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const GamesGameSlugIndexRoute = GamesGameSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GamesGameSlugRoute
          })
const GamesGameSlugHistoryRoute = GamesGameSlugHistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => GamesGameSlugRoute
          })
const StatesStateSlugIndexRoute = StatesStateSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => StatesStateSlugRoute
          })
const StatesStateSlugClaimPrizeRoute = StatesStateSlugClaimPrizeRouteImport.update({
            id: '/claim-prize',path: '/claim-prize',getParentRoute: () => StatesStateSlugRoute
          })
const ToolsTaxCalculatorIndexRoute = ToolsTaxCalculatorIndexRouteImport.update({
            id: '/tools/tax-calculator/',path: '/tools/tax-calculator/',getParentRoute: () => rootRouteImport
          })
const ToolsTaxCalculatorStateSlugRoute = ToolsTaxCalculatorStateSlugRouteImport.update({
            id: '/tools/tax-calculator/$stateSlug',path: '/tools/tax-calculator/$stateSlug',getParentRoute: () => rootRouteImport
          })
const StateSlugGameSlugResultsDateRoute = StateSlugGameSlugResultsDateRouteImport.update({
            id: '/results/$date',path: '/results/$date',getParentRoute: () => StateSlugGameSlugRoute
          })
const GamesGameSlugResultsDateRoute = GamesGameSlugResultsDateRouteImport.update({
            id: '/results/$date',path: '/results/$date',getParentRoute: () => GamesGameSlugRoute
          })
const StatesStateSlugInstantGameSlugRoute = StatesStateSlugInstantGameSlugRouteImport.update({
            id: '/instant/$gameSlug',path: '/instant/$gameSlug',getParentRoute: () => StatesStateSlugRoute
          })





const StateSlugGameSlugRouteChildren = {
  StateSlugGameSlugHistoryRoute: StateSlugGameSlugHistoryRoute,StateSlugGameSlugIndexRoute: StateSlugGameSlugIndexRoute,StateSlugGameSlugResultsDateRoute: StateSlugGameSlugResultsDateRoute
}

const StateSlugGameSlugRouteWithChildren = StateSlugGameSlugRoute._addFileChildren(StateSlugGameSlugRouteChildren)




const GamesGameSlugRouteChildren = {
  GamesGameSlugHistoryRoute: GamesGameSlugHistoryRoute,GamesGameSlugIndexRoute: GamesGameSlugIndexRoute,GamesGameSlugResultsDateRoute: GamesGameSlugResultsDateRoute
}

const GamesGameSlugRouteWithChildren = GamesGameSlugRoute._addFileChildren(GamesGameSlugRouteChildren)




const StatesStateSlugRouteChildren = {
  StatesStateSlugClaimPrizeRoute: StatesStateSlugClaimPrizeRoute,StatesStateSlugIndexRoute: StatesStateSlugIndexRoute,StatesStateSlugInstantGameSlugRoute: StatesStateSlugInstantGameSlugRoute
}

const StatesStateSlugRouteWithChildren = StatesStateSlugRoute._addFileChildren(StatesStateSlugRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,MyPicksRoute: MyPicksRoute,RoutesIndexRoute: RoutesIndexRoute,SeoStatusRoute: SeoStatusRoute,StateSlugGameSlugRoute: StateSlugGameSlugRouteWithChildren,AdminGamesRoute: AdminGamesRoute,AdminNewsletterRoute: AdminNewsletterRoute,Cash4lifeHowToPlayRoute: Cash4lifeHowToPlayRoute,GamesGameSlugRoute: GamesGameSlugRouteWithChildren,GoLinkIdRoute: GoLinkIdRoute,LottoAmericaHowToPlayRoute: LottoAmericaHowToPlayRoute,MegaMillionsHowToPlayRoute: MegaMillionsHowToPlayRoute,MegaMillionsJackpotAnalysisRoute: MegaMillionsJackpotAnalysisRoute,PowerballHowToPlayRoute: PowerballHowToPlayRoute,PowerballJackpotAnalysisRoute: PowerballJackpotAnalysisRoute,ResultsDateRoute: ResultsDateRoute,StatesStateSlugRoute: StatesStateSlugRouteWithChildren,ToolsFrequencyAnalyzerRoute: ToolsFrequencyAnalyzerRoute,ToolsNumberGeneratorRoute: ToolsNumberGeneratorRoute,ToolsPayoutCalculatorRoute: ToolsPayoutCalculatorRoute,ToolsResultsCheckerRoute: ToolsResultsCheckerRoute,AdminIndexRoute: AdminIndexRoute,ResultsIndexRoute: ResultsIndexRoute,StatesIndexRoute: StatesIndexRoute,ToolsIndexRoute: ToolsIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute,ToolsTaxCalculatorStateSlugRoute: ToolsTaxCalculatorStateSlugRoute,ToolsTaxCalculatorIndexRoute: ToolsTaxCalculatorIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)